<template>
  <div class="footer">
      <div class="banxin">
        <br>
        <table border="0" style="width: 100%;">
          <tr style="height: 28px">
            <td style="font-size: 14px;padding-left: 60px;width: 20%">客服热线</td>
            <td style="font-size: 14px;width: 16%"><a>购物指南</a></td>
            <td style="font-size: 14px;width: 16%"><a>配送服务</a></td>
            <td style="font-size: 14px;width: 16%"><a>售后服务</a></td>
            <td style="font-size: 14px;width: 16%"><a>增值服务</a></td>
            <td style="font-size: 14px;width: 16%"><a @click="goSiteConfig(1)">关于泓广</a></td>
          </tr>
          <tr style="height: 25px">
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;padding-left: 60px">13929741882</td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a>订购流程</a></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a>配送时效</a></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a>维修条款</a></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a>上门维修</a></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a @click="goSiteConfig(1)">关于泓广科技</a></td>
          </tr>
          <tr style="height: 25px">
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;padding-left: 60px">13929741882</td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a  @click="loginBtn(1)">账户注册</a></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a>退换货条款</a></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a>备机服务</a></td>
          </tr>
          <tr style="height: 25px">
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;padding-left: 60px">工作时间</td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a @click="loginBtn(2)">账户登录</a></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"></td>
<!--            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a>图书季度换新</a></td>-->
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"></td>
          </tr>
          <tr style="height: 25px">
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;padding-left: 60px">周一到周五 8:30-18:00</td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a>开票事宜</a></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"></td>
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"></td>
<!--            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"><a>党建方案</a></td>-->
            <td style=" font-size: 12px; font-weight: normal;opacity: .64;"></td>
          </tr>
        </table>
<!--        <br>-->
<!--        <hr style="border:none;border-top: 1px solid #e9e9e9;">-->
        <br>
        <p class="bottom">
              <!-- 电话:4008 321 328
              <br> -->
<!--          公司名称：{{footerInfo.companyName}}-->
<!--          <br>-->
          统一社会信用代码（税号）：{{footerInfo.creditCode}}
          <br>
          {{footerInfo.copyRight}}  <a :href="url" target="_blank">{{footerInfo.icp}}</a>
          <br>
          地址：{{footerInfo.companyAddress}}
          <br />
          技术支持：<a :href="ciaoUrl" target="_blank">深圳市才奥科技有限公司</a>
<!--          <img src="../../assets/images/footerImg.png" style="vertical-align: middle;margin-right: 5px;position: relative;top: -1px;"/>-->
<!--          {{footerInfo.guangdongPublic}}-->

        </p>
      </div>
  </div>
</template>
<script>
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";

export default {
  mixins: [listSearchMixin],
  data () {
    return {
      url:"https://beian.miit.gov.cn/",
	    pathList: ['/about','/realize','/collaborate','/contact'],
	    footerInfo: {},
      ciaoUrl:"http://www.ciaokj.com/",
    }
  },
  created() {
  	this.getNewCopyRight()
  },
  methods:{
    loginBtn (type) {
      this.$router.push({path: '/login', query: {type: type}})
    },
    goSiteConfig(type) {
      this.$router.push({path: '/about', query: {type}})
    },

	  goUsDetail(type){
		  this.$router.push({path:this.pathList[+type-1],query:{type}})
	  },
	  //获取底部信息
	  getNewCopyRight(){
		  let params = {
		    url: api.getNewCopyRight,
		    method: 'get',
		    data: {
		    }
		  }
		  this.sendReq(params, (res) => {
			if(res.success){
				this.footerInfo = res.data
			}
		  })
	  }
  }
}
</script>
<style lang = "scss" scoped>
.footer{
    width: 100%;
    /* height: 384px; */
	/* height: 334px; */
    /* height: 434px; */
    padding-bottom: 20px;
    background-color: #000000;
    opacity: 0.82;
    color: #FFFFFF;
    overflow: hidden;
    .banxin{
      a:hover {
        color: red;
      }

        width: 1252px;
        height: 100%;
        margin: 0 auto;
        .top{
			      margin-top: 50px;
            display: flex;
            margin-bottom: 38px;
            text-align: center;
            .leftBox{
                flex: 1;
                display: flex;
                flex-direction: column;
                .title{
                    font-size: 16px;
                    margin-bottom: 33px;
                }
                .number{
                    font-size: 40px;
                    margin-bottom: 12px;
                    font-weight: 500;
                }
                .time{
                    font-size: 18px;
                    margin-bottom: 33px;
                }
                .consult{
                    cursor: pointer;
                    margin: 0 auto;
                    width: 220px;
                    height: 36px;
                    line-height: 36px;
                    border: 1px solid #FFFFFF;
                    box-sizing: border-box;
                    opacity: 0.6;
                }
            }
            .centerBox{
                flex: 1;
                border-left: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
                border-right: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
                p{
                    font-size: 16px;
                    line-height: 25px;
                }
                .title{
                    margin-bottom: 33px;
                }
            }
            .rightBox{
                flex: 1;
                display: flex;
                .aboutUs{
                    flex: 1;
                    p{
                        margin-bottom: 20px;
                    }
                    .title{
                        margin-bottom: 33px;
                    }
                }
                .qrCode{
                    flex: 1;
                    .title{
                        margin-bottom: 33px;
                    }
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
            }
        }
        .bottom{
            text-align: center;
            font-size: 12px;
            line-height: 24px;
            color: white;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/footer.vue